<div sxPadding="medium">
  <h1>Features</h1>
  <ion-accordion-group expand="inset" [multiple]="true">


    <ion-accordion *ngFor="let groupedFeature of groupedFeatures" sxMargin="0 0 10px 0" sxBorderWidth="1px"
                   sxBorderColor="one" sxRadius="medium">


      <ion-item slot="header">
        <p sxTextWeight="bold">{{groupedFeature.group}}</p>
      </ion-item>


      <div slot="content">
        <div sxRow sxGap="10px" *ngFor="let feature of groupedFeature.features"
             sxDistribution="spaceBetween"
             sxAlign="center"
             sxBorderColor="one" sxBorderWidth="1px 0 0"
             sxPadding="medium">
          <div>
            <p sxMargin="0" sxTextSize="16px" sxColor="three" sxTextWeight="bold">{{feature.name}}</p>
            <p sxTextSize="12px">Default Quota {{feature.defaultQuota}}</p>
          </div>
          <div sxRow>
            <super-button *ngIf="showEditOptions" color="danger" padding="0" height="fit" type="clear" confirmationTitle="Delete Feature?" [action]="delete.bind(this,feature._id)">Delete</super-button>
            <super-button *ngIf="showEditOptions" padding="0" height="fit" type="clear" (click)="onUpdateClicked(feature)">Edit</super-button>
            <super-button *ngIf="showAddButton" padding="0" height="fit" type="clear" (click)="onAddClicked(feature)">Add</super-button>
          </div>
        </div>

      </div>
    </ion-accordion>

  </ion-accordion-group>

</div>
